import React from 'react';
import { Button, Dialog, DialogContent, DialogTitle, DialogContentText, DialogActions } from '@mui/material';

interface PlanetDeleteVersionModalProps {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	onValidate: () => void;
}

export const PlanetDeleteVersionModal: React.FC<PlanetDeleteVersionModalProps> = ({ isOpen, setIsOpen, onValidate }) => {
	return (
		<Dialog open={isOpen} onClose={() => setIsOpen(false)} maxWidth="md" fullWidth>
			<DialogTitle>Supprimer la version</DialogTitle>
			<DialogContent>
				<DialogContentText>Êtes-vous sûr de vouloir supprimer cette version ? Cette action est irréversible.</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onValidate}>Confirmer</Button>
				<Button onClick={() => setIsOpen(false)}>Annuler</Button>
			</DialogActions>
		</Dialog>
	);
};
